<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onMove($event)"
     (pointerup)="onUp($event)"
     (pointercancel)="onUp($event)"
     (pointerleave)="onUp($event)">

  <defs>
    <linearGradient id="tg-water" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#0e5e6e" />
      <stop offset="55%" stop-color="#0a4657" />
      <stop offset="100%" stop-color="#082f42" />
    </linearGradient>
    <radialGradient id="tg-buoy" cx="38%" cy="30%" r="75%">
      <stop offset="0%" stop-color="#fff2cf" />
      <stop offset="45%" stop-color="#ffcf5e" />
      <stop offset="100%" stop-color="#e0871f" />
    </radialGradient>
    <radialGradient id="tg-gem" cx="40%" cy="30%" r="75%">
      <stop offset="0%" stop-color="#d6fff6" />
      <stop offset="50%" stop-color="#4fe6c8" />
      <stop offset="100%" stop-color="#1b9e88" />
    </radialGradient>
    <filter id="tg-glow" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="4" result="b" /><feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
    </filter>
  </defs>

  <!-- Water panel (full-bleed) -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" fill="url(#tg-water)" />

  <!-- Faint swells -->
  <g stroke="rgba(255,255,255,0.05)" stroke-width="3" fill="none">
    <path [attr.d]="'M0,70 Q250,50 500,70 T1000,70'" />
    <path [attr.d]="'M0,150 Q250,132 500,150 T1000,150'" />
  </g>

  <!-- Compass rose (top-right decor) -->
  <g class="compass" [attr.transform]="'translate(945,88)'" opacity="0.9">
    <circle r="34" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2" />
    <polygon points="0,-30 7,0 0,30 -7,0" fill="rgba(255,255,255,0.28)" />
    <polygon points="-30,0 0,-7 30,0 0,7" fill="rgba(255,255,255,0.18)" />
    <polygon points="0,-30 5,-6 -5,-6" fill="#ff9269" />
    <text x="0" y="-38" text-anchor="middle" class="compass-n">N</text>
  </g>

  <!-- Grid lines (full four-quadrant extent) -->
  <g class="grid">
    <line *ngFor="let i of xTicks" [attr.x1]="px(i)" [attr.y1]="gridTop" [attr.x2]="px(i)" [attr.y2]="gridBottom" />
    <line *ngFor="let j of yTicks" [attr.x1]="gridLeft" [attr.y1]="py(j)" [attr.x2]="gridRight" [attr.y2]="py(j)" />
  </g>

  <!-- Axes (cross at the origin, arrows on both ends) -->
  <g class="axes" stroke-linecap="round">
    <line class="axis x" [attr.x1]="gridLeft - 24" [attr.y1]="OY" [attr.x2]="gridRight + 24" [attr.y2]="OY" />
    <line class="axis y" [attr.x1]="OX" [attr.y1]="gridBottom + 24" [attr.x2]="OX" [attr.y2]="gridTop - 24" />
    <polygon [attr.points]="(gridRight + 24) + ',' + (OY - 8) + ' ' + (gridRight + 40) + ',' + OY + ' ' + (gridRight + 24) + ',' + (OY + 8)" [attr.fill]="X_CLR" />
    <polygon [attr.points]="(gridLeft - 24) + ',' + (OY - 8) + ' ' + (gridLeft - 40) + ',' + OY + ' ' + (gridLeft - 24) + ',' + (OY + 8)" [attr.fill]="X_CLR" />
    <polygon [attr.points]="(OX - 8) + ',' + (gridTop - 24) + ' ' + OX + ',' + (gridTop - 40) + ' ' + (OX + 8) + ',' + (gridTop - 24)" [attr.fill]="Y_CLR" />
    <polygon [attr.points]="(OX - 8) + ',' + (gridBottom + 24) + ' ' + OX + ',' + (gridBottom + 40) + ' ' + (OX + 8) + ',' + (gridBottom + 24)" [attr.fill]="Y_CLR" />
  </g>

  <!-- Tick labels -->
  <text class="origin" [attr.x]="OX - 18" [attr.y]="OY + 26" [style.font-size.px]="labelFont" text-anchor="middle">0</text>
  <text *ngFor="let i of xLabels" class="xlab" [class.hot]="placed && i === gx"
        [attr.x]="px(i)" [attr.y]="OY + 28" [style.font-size.px]="labelFont" text-anchor="middle">{{ i }}</text>
  <text *ngFor="let j of yLabels" class="ylab" [class.hot]="placed && j === gy"
        [attr.x]="OX - 20" [attr.y]="py(j) + 7" [style.font-size.px]="labelFont" text-anchor="middle">{{ j }}</text>

  <!-- Crosshair guides (colour-coded: x cyan across, y coral up) -->
  <g *ngIf="placed && !solvedState" class="cross">
    <line class="cx" [attr.x1]="markerX" [attr.y1]="OY" [attr.x2]="markerX" [attr.y2]="markerY" [attr.stroke]="X_CLR" />
    <line class="cy" [attr.x1]="OX" [attr.y1]="markerY" [attr.x2]="markerX" [attr.y2]="markerY" [attr.stroke]="Y_CLR" />
  </g>

  <!-- Marker / treasure -->
  <g class="marker" [class.win]="solvedState" [attr.transform]="'translate(' + markerX + ',' + markerY + ')'">
    <g *ngIf="!solvedState">
      <circle class="ring" [class.hot]="onTarget" r="20" />
      <circle class="dot" r="7" />
      <!-- readout flag (flips below on the top row) -->
      <g [attr.transform]="'translate(0,' + readoutDy + ')'">
        <rect class="readout" [class.hot]="onTarget" [attr.x]="-readoutW / 2" y="-20" [attr.width]="readoutW" height="40" rx="10" />
        <text class="readout-text" x="0" y="1" text-anchor="middle" dominant-baseline="central">{{ readoutLabel }}</text>
      </g>
    </g>
    <!-- Treasure-found burst -->
    <g *ngIf="solvedState" class="treasure">
      <!-- shockwave rings -->
      <circle class="t-ring r1" cx="0" cy="0" r="20" />
      <circle class="t-ring r2" cx="0" cy="0" r="20" />

      <!-- rotating sunburst -->
      <g class="t-rays">
        <rect *ngFor="let a of rayAngles" class="t-ray" x="-4" y="-120" width="8" height="66" rx="4"
              [attr.transform]="'rotate(' + a + ')'" />
      </g>

      <!-- sparkles -->
      <circle *ngFor="let s of sparkles" class="sparkle" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
              [style.animation-delay.ms]="s.delay" />

      <!-- coin & gem fountain -->
      <g *ngFor="let c of coins" class="t-coin" [class.gem]="c.gem"
         [style.--tx]="c.tx + 'px'" [style.--ty]="c.ty + 'px'" [style.--rot]="c.rot + 'deg'"
         [style.animation-delay.ms]="c.delay">
        <circle [attr.r]="c.r" [attr.fill]="c.gem ? 'url(#tg-gem)' : 'url(#tg-buoy)'" />
        <circle class="shine" [attr.r]="c.r * 0.38" [attr.cx]="-c.r * 0.3" [attr.cy]="-c.r * 0.3" />
      </g>

      <!-- the diamond -->
      <g class="t-gem" filter="url(#tg-glow)">
        <polygon class="gem-body" points="0,-34 27,-8 0,40 -27,-8" fill="url(#tg-gem)" />
        <polygon class="gem-crown" points="0,-34 27,-8 -27,-8" />
        <line class="gem-facet" x1="-27" y1="-8" x2="27" y2="-8" />
        <line class="gem-facet" x1="-14" y1="-8" x2="0" y2="40" />
        <line class="gem-facet" x1="14" y1="-8" x2="0" y2="40" />
        <line class="gem-facet" x1="0" y1="-34" x2="0" y2="-8" />
      </g>
    </g>
  </g>

  <!-- Full-grid drag surface -->
  <rect class="drag-band" [attr.x]="gridLeft - 45" [attr.y]="gridTop - 45"
        [attr.width]="(gridRight - gridLeft) + 90" [attr.height]="(gridBottom - gridTop) + 90"
        fill="transparent" (pointerdown)="onDown($event)" />

  <!-- Wrong wash -->
  <rect *ngIf="wrongFlash" class="wrong-flash" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" />
</svg>
